(function($) {
  "use strict";
  $(function() {
    $.findObjectByKey = function findObjectByKey(array, key, value) {
      if (array == null) {
        return null;
      }

      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
      return null;
    };

    $.convertTicketName = function convertTicketName(str) {
      if (str == null) {
        str = "-";
      } else {
        str = str.replace(
          /Kedvezményes elővételes.*/g,
          localize.translations.ticket__preferential
        );
        str = str.replace(/Normál.*/g, localize.translations.ticket__normal);
        str = str.replace(/VIP.*/g, "VIP");
      }

      return str;
    };

    $(document).on("click", ".js-close-modal-tickets", function(e) {
      $("#modal-tickets").iziModal("close");
    });

    $(document).on("click", ".js-close-modal-cooltix", function(e) {
      $("#modal-cooltix").iziModal("close");
    });

    if ($(".js-cooltix-modal").length) {
      const referrerUrl = window.location.href;
      let lang = Cookies.get("_icl_current_language");

      if (lang == undefined) {
        lang = Cookies.get("wp-wpml_current_language");
      }

      const cooltix_id = $(".js-cooltix-modal").data("id");
      const consent = Cookies.get("DONEGDPRAlertBoxClosed")
        ? "accepted"
        : "rejected";

      let iframeURL = `https://cooltix.com/widget/event-products/${cooltix_id}?primaryColorHex=5F4B8B&locale=${lang}&referrerUrl=${referrerUrl}`;
      if (consent === "accepted") {
        iframeURL += `&cookieConsent=${consent}`;
      }

      $(".js-cooltix-modal").iziModal({
        zindex: 9999,
        iframe: true,
        iframeURL,
        iframeHeight: "80dvh",
        zindex: 9999,
        width: "90vw",
      });
    }

    if ($(".js-tickets").length || $(".template-single-programs").length) {
      axios
        .get(localize.ticketsJson + "?v=" + Date.now(), {
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        })
        .then(function(response) {
          $.tickets = response.data.products;

          $(document).on("click", ".js-buy-ticket", function() {
            var sum = $(this)
              .parent()
              .find(".ctrl-counter-input")
              .val();
            var id = $(this).data("id");
            var $currentTicket = $.findObjectByKey($.tickets, "id", id);
            var max = $currentTicket.cart_limit;
            if (sum < 1) {
              sum = 1;
            }
            if (sum > max) {
              sum = max;
            }
            window.location.href =
              localize.basket + $(this).data("id") + "/" + sum;
          });

          $(document).on("click", ".ctrl-button-increment", function() {
            var $parent = $(this).parent();
            var currentval = parseInt(
              $parent.find(".ctrl-counter-input").val()
            );
            var id = $(this)
              .closest(".ticket__item")
              .find(".js-buy-ticket")
              .data("id");
            var $currentTicket = $.findObjectByKey($.tickets, "id", id);
            var max = $currentTicket.cart_limit;
            if (currentval < max) {
              $parent.find(".ctrl-counter-input").val(currentval + 1);
              $parent.find(".ctrl-counter-num").text(currentval + 1);
              $parent.find(".ctrl-button-decrement").removeClass("inactive");
              if (currentval + 1 == max) {
                $(this).addClass("inactive");
              }
            }
          });

          $(document).on("click", ".ctrl-button-decrement", function() {
            var $parent = $(this).parent();
            var currentval = parseInt(
              $parent.find(".ctrl-counter-input").val()
            );
            if (currentval > 1) {
              $parent.find(".ctrl-counter-input").val(currentval - 1);
              $parent.find(".ctrl-counter-num").text(currentval - 1);
              $parent.find(".ctrl-button-increment").removeClass("inactive");
              if (currentval - 1 == 1) {
                $(this).addClass("inactive");
              }
            }
          });

          if ($(".template-single-programs").length) {
            $(".js-tickets-modal").iziModal({
              history: false,
              iframe: false,
              fullscreen: false,
              loop: false,
              width: 800,
              borderBottom: false,
              radius: 0,
              arrowKeys: false,
              bodyOverflow: true,
              navigateCaption: false,
              zindex: 9999,
            });

            var $program_id = $(".template-single-programs").data("id");
            var $currentTickets = localize.programs[$program_id];
            var $allTickets = $currentTickets.tickets;

            var langCookie = Cookies.get("_icl_current_language");
            if (langCookie == undefined) {
              langCookie = Cookies.get("wp-wpml_current_language");
            }

            /* All tickets */
            var $sticky_sold_text = localize.translations.all_tickets_sold;
            $.each($allTickets, function(i, val) {
              var $currentTicket = $.findObjectByKey(
                $.tickets,
                "code",
                val.toString()
              );
              var curr_el = i;

              if ($currentTicket) {
                if ($currentTicket.sold_out_info) {
                  $sticky_sold_text = $currentTicket.sold_out_info;
                }
                function getPreferentialText($currentTicket) {
                  if ($currentTicket.selling_status !== "coming_soon")
                    return "";

                  return `
                                        <h5 class="ticket__preferential coming--soon">
                                            ${
                                              localize.translations.selling_from
                                            } ${formatDate(
                    $currentTicket.selling_from
                  )}
                                        </h5>`;
                }

                function getTicketTitle($currentTicket) {
                  const isAvailable = ["available", "coming_soon"].includes(
                    $currentTicket.selling_status
                  );
                  return `<h5 class="ticket__title ${
                    !isAvailable ? "allticket--sold" : ""
                  }">${$currentTicket.marketing_title}</h5>`;
                }

                function getDescription($currentTicket) {
                  if (!$currentTicket.marketing_description) return "";

                  return `<div class="item__desc">${$currentTicket.marketing_description}</div>`;
                }

                function getValidityText($currentTicket, langCookie) {
                  if (!$currentTicket.valid_from) return "";

                  const format =
                    langCookie === "hu" ? "YYYY. MMMM DD" : "MMMM DD, YYYY";

                  let validTo =
                    $currentTicket.selling_to || $currentTicket.valid_from;

                  for (const phase of $currentTicket.price_phases) {
                    if (
                      phase.price_status === "active" &&
                      phase.selling_to !== undefined &&
                      phase.selling_to !== null
                    ) {
                      validTo = phase.selling_to;
                    }
                  }

                  const discountText =
                    $currentTicket.valid_from !== undefined
                      ? `
                                        <p class="discount__text">
                                            ${localize.translations.discount_text.replace(
                                              /{{date}}*/g,
                                              formatDate(validTo, format)
                                            )}
                                        </p>`
                      : "";

                  const validityPeriod = `
                                        <p>
                                            ${
                                              localize.translations.valid
                                            } ${formatDate(
                    $currentTicket.valid_from
                  )}${localize.translations.from} ${formatDate(
                    $currentTicket.valid_to
                  )}${localize.translations.to}
                                        </p>`;

                  return `<div class="item__valid">${discountText}${validityPeriod}</div>`;
                }

                function getTicketPhases($currentTicket) {
                  if (!$currentTicket.price_phases) return "";

                  return `<div class="ticket__phases"></div>`;
                }

                function getBuyOptions($currentTicket) {
                  if ($currentTicket.selling_status === "coming_soon")
                    return "";

                  if ($currentTicket.selling_status === "available") {
                    const isIncrementInactive =
                      $currentTicket.cart_limit == 1 ? "inactive" : "";
                    return `
                                            <div class='ctrl'>
                                                <div class='ctrl-text'>${localize.translations.quantity}</div>
                                                <div class='ctrl-button ctrl-button-decrement inactive'>-</div>
                                                <div class='ctrl-counter'>
                                                    <input class='ctrl-counter-input' maxlength='${$currentTicket.cart_limit}' type='text' value='1'>
                                                    <div class='ctrl-counter-num'>1</div>
                                                </div>
                                                <div class='ctrl-button ctrl-button-increment ${isIncrementInactive}'>+</div>
                                            </div>  
                                            <button data-id="${$currentTicket.id}" class="button button--primary js-buy-ticket">${localize.translations.buy}</button>`;
                  }

                  return `<button class="button button--primary disabled">${localize.translations.sold_out}</button>`;
                }

                function formatDate(
                  dateString,
                  format = "YYYY. MMMM DD. HH:mm"
                ) {
                  return moment(dateString.toString())
                    .format(format)
                    .toLowerCase();
                }

                // Final construction of the element
                const ticketElement = `
                                    <div class="ticket__item ticket__item_${curr_el}">
                                        ${getPreferentialText($currentTicket)}
                                        ${getTicketTitle($currentTicket)}
                                        ${getDescription($currentTicket)}
                                        ${getValidityText(
                                          $currentTicket,
                                          langCookie
                                        )}
                                        ${getTicketPhases($currentTicket)}
                                        ${getBuyOptions($currentTicket)}
                                    </div>`;

                $(".js-tickets-wrapper").append(ticketElement);

                $.each($currentTicket.price_phases, function(i, val) {
                  if ($currentTicket.selling_status != "coming_soon") {
                    if (
                      val.price_status == "expired" ||
                      ($currentTicket.selling_status != "available" &&
                        val.price_status == "active")
                    ) {
                      $(`.ticket__item_${curr_el} .ticket__phases`).append(`
                                    <p class="smaller ticket__early-bird">
                                    ${$.convertTicketName(
                                      val.title
                                    )}: <span class="text-uppercase">${
                        localize.translations.sold_out
                      }</span>
                                    </p>`);
                    }

                    if (
                      val.price_status == "active" &&
                      $currentTicket.selling_status == "available"
                    ) {
                      $(`.ticket__item_${curr_el} .ticket__phases`).append(`
                                    <h5 class="ticket__preferential"><i class="fas fa-chevron-right"></i>
                                    ${$.convertTicketName(
                                      val.title
                                    )}: <span class="primary-text-color">${
                        val.gross_price
                      } ${$currentTicket.currency_sign}</span> 
                                    </h5>
                                    `);
                    }

                    if (val.price_status == "future") {
                      $(`.ticket__item_${curr_el} .ticket__phases`).append(`
                                    <p class="smaller ticket__normal">
                                        ${$.convertTicketName(
                                          val.title
                                        )}: <span class="primary-text-color">${
                        val.gross_price
                      } ${$currentTicket.currency_sign}</span>
                                    </p>
                                    `);
                    }
                  } else {
                    $(`.ticket__item_${curr_el} .ticket__phases`).append(`
                                        <p class="smaller ticket__early-bird">
                                        ${$.convertTicketName(val.title)}: ${
                      val.gross_price
                    } ${$currentTicket.currency_sign}
                                        </p>`);
                  }
                });
              }
            });

            /* Sticky ticket */
            var $sticky_sold = true;
            var maxTickets = 2;

            $.each($allTickets, function(i, val) {
              var $currentTicket = $.findObjectByKey(
                $.tickets,
                "code",
                val.toString()
              );
              if (maxTickets <= 0) {
                return;
              }

              if ($currentTicket == null) {
                return;
              }

              if ($currentTicket.selling_status == "available") {
                $sticky_sold = false;
                var $ticketCounter = 0;
                $.each($currentTicket.price_phases, function(i, val) {
                  if (val.price_status == "active") {
                    if ($(".js-sticky-prices .coming-soon-ticket").length) {
                      $(".js-sticky-prices").html("");
                      $(".hero-card__button.internal").removeClass(
                        "button--secondary"
                      );
                    }

                    $(".js-sticky-prices").append(`
                            <h5 class="ticket__preferential">
                            ${$.convertTicketName(
                              val.title
                            )}: <span class="primary-text-color">${
                      val.gross_price
                    } ${$currentTicket.currency_sign}</span> 
                            </h5>
                           ${
                             val.selling_to != undefined
                               ? ` <p class="ticket__desc">

                           ${
                             langCookie == "hu"
                               ? `${localize.translations.discount_text.replace(
                                   /{{date}}*/g,
                                   moment(val.selling_to.toString())
                                     .format("YYYY. MMMM DD")
                                     .toLowerCase()
                                 )}`
                               : `${localize.translations.discount_text.replace(
                                   /{{date}}*/g,
                                   moment(val.selling_to.toString()).format(
                                     "MMMM DD, YYYY"
                                   )
                                 )}`
                           }
                            
                            </p>`
                               : ``
                           }
                            `);

                    $ticketCounter++;
                    maxTickets--;
                  }

                  /*                 if (val.price_status == "future") {
                                                        $('.js-sticky-prices').append(`
                                            <p class="smaller ticket__normal">
                                                ${$.convertTicketName(val.title)}: <span class="primary-text-color">${val.gross_price} ${$currentTicket.currency_sign}</span>
                                            </p>
                                            `);
                                                    } */
                });

                if ($ticketCounter >= 2) {
                  return false;
                }
              }

              if (
                $currentTicket.selling_status == "coming_soon" &&
                !$(".js-sticky-prices .ticket__preferential").length
              ) {
                $sticky_sold = false;
                $(".hero-card__button.internal").addClass("button--secondary");
                $(".js-sticky-prices").append(`
                                <h5 class="ticket__preferential coming-soon-ticket" data-date="${moment(
                                  $currentTicket.selling_from.toString()
                                ).format("YYYY-MM-DD HH:mm")}">
                                ${
                                  localize.translations.selling_from
                                }<br>${moment(
                  $currentTicket.selling_from.toString()
                )
                  .format("YYYY. MMMM DD. HH:mm")
                  .toLowerCase()}
                                </h5>
                              
                                `);
                var mincoming = moment(
                  $currentTicket.selling_from.toString()
                ).format("YYYY-MM-DD HH:mm");
                var minindex = 0;

                $(".js-sticky-prices")
                  .find(".coming-soon-ticket")
                  .each(function(i, e) {
                    $(this).hide();
                    var cmin = moment($(this).data("date")).format(
                      "YYYY-MM-DD HH:mm"
                    );

                    if (cmin <= mincoming) {
                      mincoming = cmin;
                      minindex = i;
                    }
                  });

                var toshowcoming = $(".js-sticky-prices")
                  .find(".coming-soon-ticket")
                  .eq(minindex)
                  .data("date");
                $(
                  `.js-sticky-prices .coming-soon-ticket[data-date="${toshowcoming}"]`
                ).show();
              }
            });
            if ($sticky_sold) {
              $(".hero-card__button.internal").addClass("button--secondary");
              $(".js-sticky-prices").html(`
                            <h5 class="ticket__preferential">
                            ${$sticky_sold_text}
                            </h5>
                          
                            `);
            }

            $(".hero-card__button").addClass("active");
          }

          if ($(".js-tickets").length) {
            $(".js-tickets").each(function(index, el) {
              var $program_id = $(this).data("id");
              var $currentTickets = localize.programs[$program_id];
              var $that = $(this);
              var $tickets_sold = true;
              var $notickets = false;
              var $isfree = $currentTickets.isfree;
              var $isexternal = $currentTickets.external;
              var $issoldout = $currentTickets.soldout;

              if ($currentTickets.tickets != undefined) {
                var $allTickets = $currentTickets.tickets;
                var maxTickets = 2;
                $.each($allTickets, function(i, val) {
                  var $currentTicket = $.findObjectByKey(
                    $.tickets,
                    "code",
                    val.toString()
                  );
                  if (maxTickets <= 0) {
                    return;
                  }
                  if ($currentTicket) {
                    $notickets = false;
                    if ($currentTicket.selling_status == "available") {
                      $tickets_sold = false;
                      var $ticketCounter = 0;
                      $.each($currentTicket.price_phases, function(i, val) {
                        if ($ticketCounter < 2) {
                          if (val.price_status == "active") {
                            if ($that.find(".coming-soon-ticket").length) {
                              $that.html("");
                              $that.next(".js-tickets-button").html("");
                            }

                            // $that.append(`<p class="price--large available-ticket strong">${$.convertTicketName(val.title)}: ${val.gross_price} ${$currentTicket.currency_sign}</p>`);
                            $ticketCounter++;
                            maxTickets--;
                          }

                          /*        if (val.price_status == "future") {
       
                                                               $that.append(`<p class="price--small strong">${$.convertTicketName(val.title)}: ${val.gross_price} ${$currentTicket.currency_sign}</p>`);
                                                           }
       
                                                           if (val.price_status == "active" || val.price_status == "future") {
                                                               $ticketCounter++;
                                                           } */
                        }
                      });

                      if (
                        !$that.next(".js-tickets-button").find("button").length
                      ) {
                        $that.next(".js-tickets-button")
                          .append(` <button class="button button--primary">
                                        ${localize.translations.buy}
                                        </button>`);
                      }

                      if ($ticketCounter >= 2) {
                        return false;
                      }
                    }

                    if (
                      $currentTicket.selling_status == "coming_soon" &&
                      !$that.find(".available-ticket").length
                    ) {
                      $tickets_sold = false;
                      // $that.append(`<p class="price--large coming--soon strong coming-soon-ticket" data-date="${moment($currentTicket.selling_from.toString()).format('YYYY-MM-DD HH:mm')}">${localize.translations.selling_from}<br>${moment($currentTicket.selling_from.toString()).format('YYYY. MMMM DD. HH:mm').toLowerCase()}</p>`);
                      $that.next(".js-tickets-button")
                        .html(` <button class="button button--secondary">
                                                    ${localize.translations.details}
                                                    </button>`);

                      var mincoming = moment(
                        $currentTicket.selling_from.toString()
                      ).format("YYYY-MM-DD HH:mm");
                      var minindex = 0;

                      $that.find(".coming-soon-ticket").each(function(i, e) {
                        $(this).hide();
                        var cmin = moment($(this).data("date")).format(
                          "YYYY-MM-DD HH:mm"
                        );

                        if (cmin <= mincoming) {
                          mincoming = cmin;
                          minindex = i;
                        }
                      });

                      $that
                        .find(".coming-soon-ticket")
                        .eq(minindex)
                        .show();
                    }
                  } else {
                    $notickets = true;
                  }
                });
              }

              if (
                $currentTickets.tickets != undefined &&
                ($currentTickets.tickets.length == 1 || maxTickets == 1) &&
                !$notickets &&
                !$issoldout &&
                !$tickets_sold
              ) {
                // $that.append(
                //   `<p class="price--large strong price-placeholder">&nbsp;</p>`
                // );
              }

              if (
                $currentTickets.tickets == undefined ||
                $currentTickets.tickets.length == 0 ||
                $notickets
              ) {
                if ($isexternal && !$issoldout) {
                  //   $that.append(`<p class="price--large strong">&nbsp;</p>`);
                  //   $that.append(`<p class="price--large strong">&nbsp;</p>`);
                  $that.next(".js-tickets-button")
                    .append(` <button class="button button--primary">
                                         ${localize.translations.buy}
                                        </button>`);
                } else {
                  //   if ($isfree) {
                  //     // $that.append(
                  //     //   `<p class="price--large strong">${localize.translations.free}</p>`
                  //     // );
                  //     // $that.append(`<p class="price--large strong">&nbsp;</p>`);
                  //   } else if ($issoldout) {
                  //     // $that.append(
                  //     //   `<p class="price--large strong">${localize.translations.all_tickets_sold}</p>`
                  //     // );
                  //     // $that.append(`<p class="price--large strong">&nbsp;</p>`);
                  //   } else {
                  //     // $that.append(`<p class="price--large strong">&nbsp;</p>`);
                  //     // $that.append(`<p class="price--large strong">&nbsp;</p>`);
                  //   }

                  $that.next(".js-tickets-button")
                    .append(` <button class="button button--secondary">
                                        ${localize.translations.details}
                                        </button>`);
                }
                return;
              }

              if ($tickets_sold && !$notickets) {
                // $that.append(
                //   `<p class="price--large strong">${localize.translations.all_tickets_sold}</p>`
                // );
                // $that.append(`<p class="price--large strong">&nbsp;</p>`);
                $that.next(".js-tickets-button")
                  .append(` <button class="button button--secondary">
                                        ${localize.translations.details}
                                        </button>`);
              }
            });
          }
          if ($.grid != undefined) {
            $.grid.isotope();
          }
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        })
        .then(function() {
          // always executed
        });
    }
  });
})(jQuery);
